
  var _styles = {
  "cfe-letter-index-wrap": {
    "position": "absolute",
    "top": 0,
    "right": 0,
    "bottom": 0,
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "paddingTop": 0,
    "paddingRight": "0.16rem",
    "paddingBottom": 0,
    "paddingLeft": "0.16rem"
  },
  "cfe-letter-index-list": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center"
  },
  "cfe-letter-item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "0.53333rem",
    "height": "0.53333rem",
    "borderRadius": "0.53333rem"
  },
  "cfe-letter-item-active": {
    "backgroundColor": "rgb(255,224,0)"
  },
  "cfe-letter-text": {
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "color": "rgb(34,34,34)",
    "fontFamily": "PingFang SC",
    "textAlign": "center"
  },
  "cfe-letter-text-active": {
    "color": "rgb(255,255,255)"
  },
  "cfe-letter-bubble": {
    "position": "absolute",
    "left": "-1.06667rem",
    "top": 0,
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "0.93333rem",
    "height": "0.93333rem",
    "borderRadius": "0.46667rem",
    "backgroundColor": "rgb(255,224,0)"
  },
  "cfe-letter-bubble-text": {
    "fontSize": "0.53333rem",
    "lineHeight": "0.69333rem",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600"
  }
};



  module.exports = _styles;
  